exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#mismatch-application-form {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.w100 {\n  width: 100%;\n}\n", ""]);

// exports
